var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70743 5.46276V16.2583C6.55029 15.9623 5.22254 16.0363 4.15441 16.4506C1.81787 17.3534 0.0599049 20.1207 0.838751 21.9927C1.70661 24.0793 5.59342 24.6786 7.97447 23.1248C9.13903 22.3626 10.2294 20.8902 10.3333 19.4325H10.3481V11.5819L20.5992 8.31147V12.1813C19.442 11.8853 18.1143 11.9593 17.0462 12.3737C14.7096 13.2764 12.9517 16.0437 13.7305 17.9157C14.5984 20.0023 18.4852 20.6016 20.8662 19.0478C22.0308 18.2857 23.1212 16.8132 23.225 15.3556H23.2398V0.62365C23.2398 0.201893 22.8245 -0.101476 22.4239 0.0317104L8.43436 4.47866C8.00414 4.61185 7.71485 5.0114 7.71485 5.46276H7.70743ZM20.5918 5.54415L10.3407 8.81462V6.63924L20.5918 3.36877V5.54415Z",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("title", null, "Music Note")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMusic);
export default __webpack_public_path__ + "static/media/map_music.f2557c6f.svg";
export { ForwardRef as ReactComponent };